var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-payment-category-bundle-items","size":"xl","title":"Isi Paket Bundle","cancel-title":"Batal","hide-footer":"","ok-title":"Oke"},on:{"ok":_vm.modalOnSubmit}},[_c('Table',{attrs:{"items":_vm.items},on:{"checkboxItemOnChange":_vm.checkboxItemOnChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }